import { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import React from 'react';
import ContactSection from "./sections/ContactSection";
import Intro from "./sections/Intro";
import History from "./sections/History";
import Objectives from "./sections/Objectives";
import Services from "./sections/Services";
import LanguageToggle from "../components/LanguageToggle";
import { useLanguage } from "../contexts/LanguageContext";
import HorizontalScrollSection from "./sections/HorizontalScrollSection";


const Home: React.FC = () => {
    const { tString } = useLanguage();
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="w-screen h-screen text-white flex flex-col justify-between font-poppins">
            {/* HEADER */}
            <header className="bg-[#282A2A]/80 backdrop-blur-lg shadow-md flex justify-between items-center px-10 py-4 fixed top-0 left-0 w-full z-50">

                {/* Left: Logo */}
                <img src="/images/logo_glc_blanco.png" className="h-12" />

                {/* Right: Navigation links and Language Toggle */}
                <div className="hidden md:flex space-x-8 text-lg font-medium items-center">
                    <a href="#inicio" className="hover:underline text-[#FFFFFF] transition duration-800">
                        {tString('navigation.home')}
                    </a>
                    <a href="#nosotros" className="hover:underline text-[#FFFFFF] transition duration-800">
                        {tString('navigation.about')}
                    </a>
                    <a href="#servicios" className="hover:underline text-[#FFFFFF] transition duration-800">
                        {tString('navigation.services')}
                    </a>
                    <a href="#usa" className="hover:underline text-[#FFFFFF] transition duration-800">
                        USA
                    </a>
                    <a href="#contacto" className="hover:underline text-[#FFFFFF] transition duration-800">
                        {tString('navigation.contact')}
                    </a>
                    <LanguageToggle />
                </div>


                {/* Mobile menu button and language toggle */}
                <div className="md:hidden flex items-center gap-4">
                    <LanguageToggle />
                    <button
                        className="text-[#FFFFFF]"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        {menuOpen ? <HiX size={28} /> : <HiMenu size={28} />}
                    </button>
                </div>

                {/* Mobile dropdown menu */}
                {menuOpen && (
                    <div className=" absolute top-[72px] right-0 w-full bg-[#282A2A]/90 backdrop-blur-lg shadow-md flex flex-col items-start py-3 md:hidden z-50">
                        <a href="#inicio" className="text-[#FFFFFF] hover:underline w-full text-left hover:bg-[#83C441]">
                            <span className="pl-8 py-2 inline-block">{tString('navigation.home')}</span>
                        </a>
                        <a href="#nosotros" className="text-[#FFFFFF] hover:underline w-full text-left hover:bg-[#83C441]">
                            <span className="pl-8 py-2 inline-block">{tString('navigation.about')}</span>
                        </a>
                        <a href="#servicios" className="text-[#FFFFFF] hover:underline w-full text-left hover:bg-[#83C441]">
                            <span className="pl-8 py-2 inline-block">{tString('navigation.services')}</span>
                        </a>
                        <a href="#usa" className="text-[#FFFFFF] hover:underline w-full text-left hover:bg-[#83C441]">
                            <span className="pl-8 py-2 inline-block">USA</span>
                        </a>
                        <a href="#contacto" className="text-[#FFFFFF] hover:underline w-full text-left hover:bg-[#83C441]">
                            <span className="pl-8 py-2 inline-block block">{tString('navigation.contact')}</span>
                        </a>
                    </div>
                )}

            </header>

            {/* BODY */}
            <main className="bg-[#282A2A] flex flex-col items-center text-center p-10">
                <Intro />

                <Objectives />

                <History />

                <Services />

                <div id="usa" className="-mx-10 w-screen scroll-mt-40">
                    <HorizontalScrollSection />
                </div>

                <ContactSection />


            </main >


        </div >
    );
};

export default Home;







